<template>
  <div class="bg-white shadow-sm py-3 h-100" style="border-radius: 20px">
    <div class="d-flex">
      <div class="px-4 ml-auto">تراکنش‌های اخیر</div>
      <div class="px-4">
        <router-link class="text-success" to="/transactions"
          >مشاهده کل</router-link
        >
      </div>
    </div>
    <hr />
    <div class="mx-3">
      <div
        class="table-responsive"
        v-if="status == 'ok' && transactions.length > 0"
      >
        <table class="table table-borderless text-center recent-tx">
          <thead>
            <tr>
              <th
                scope="col"
                style="background-color: #eee; border-radius: 0 16px 16px 0"
              >
                کد تراکنش
              </th>
              <th scope="col" style="background-color: #eee">نوع تراکنش</th>
              <th scope="col" style="background-color: #eee">وضعیت</th>
              <th
                scope="col"
                style="background-color: #eee; border-radius: 16px 0 0 16px"
              >
                مبلغ (ریال)
              </th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(transaction, index) in transactions"
              :key="index"
              :class="'tx-' + statusVariant(transaction.status)"
            >
              <td class="en_num">{{ transaction.id }}</td>
              <td v-if="transaction.transaction_type == 'پرداختیاری *'">
                <span>پرداخت‌یاری +</span>
              </td>
              <td
                v-else-if="
                  transaction.transaction_type == 'transaction.out_source'
                "
              >
                خارج از سامانه
              </td>
              <td v-else>{{ transaction.transaction_type }}</td>
              <td>
                <span
                  :class="[
                    'label label-inline' +
                      ' label-light-' +
                      statusVariant(transaction.status),
                    transaction.status == 'SUCCEED' ? 'px-4' : '',
                  ]"
                >
                  {{ statusStr.get(transaction.status) }}
                </span>
              </td>
              <td>{{ transaction.price }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-responsive" v-else>
        <table
          class="table table-borderless text-center"
          style="filter: blur(5px)"
        >
          <thead>
            <tr>
              <th
                scope="col"
                style="background-color: #eee; border-radius: 0 16px 16px 0"
              >
                کد تراکنش
              </th>
              <th scope="col" style="background-color: #eee">نوع تراکنش</th>
              <th scope="col" style="background-color: #eee">وضعیت</th>
              <th
                scope="col"
                style="background-color: #eee; border-radius: 16px 0 0 16px"
              >
                مبلغ (ریال)
              </th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>48545</td>
              <td>پرداخت یاری</td>
              <td>
                <span :class="'text text-lg  text-inline ' + 'text-success'">
                  موفق
                </span>
              </td>
              <td>434,660</td>
            </tr>
            <tr>
              <td>48545</td>
              <td>پرداخت یاری</td>
              <td>
                <span :class="'text text-lg  text-inline ' + 'text-success'">
                  موفق
                </span>
              </td>
              <td>434,660</td>
            </tr>
            <tr>
              <td>48545</td>
              <td>پرداخت یاری</td>
              <td>
                <span :class="'text text-lg  text-inline ' + 'text-success'">
                  موفق
                </span>
              </td>
              <td>434,660</td>
            </tr>
            <tr>
              <td>48545</td>
              <td>پرداخت یاری</td>
              <td>
                <span :class="'text text-lg  text-inline ' + 'text-success'">
                  موفق
                </span>
              </td>
              <td>434,660</td>
            </tr>
            <tr>
              <td>48545</td>
              <td>پرداخت یاری</td>
              <td>
                <span :class="'text text-lg  text-inline ' + 'text-success'">
                  موفق
                </span>
              </td>
              <td>434,660</td>
            </tr>
            <tr>
              <td>48545</td>
              <td>پرداخت یاری</td>
              <td>
                <span :class="'text text-lg  text-inline ' + 'text-success'">
                  موفق
                </span>
              </td>
              <td>434,660</td>
            </tr>
          </tbody>
        </table>
        <div class="locked-overlay" v-if="status == 'loading'">
          <div
            style="
              position: absolute;
              width: 100%;
              text-align: center;
              top: 30%;
            "
          >
            <div class="btn btn-success mt-5">
              <div class="d-flex justify-content-center align-items-center"><div class="px-2">لطفا صبر کنید</div><div class="spinner-border spinner-border-sm text-white" role="status"></div></div>
            </div>
          </div>
        </div>
        <div
          class="locked-overlay"
          v-else-if="status == 'ok' && transactions.length == 0"
        >
          <div
            style="
              position: absolute;
              width: 100%;
              text-align: center;
              top: 30%;
            "
          >
            <div>
              <div class="btn">
                <img src="@/assets/new/image/not-found_new.png" width="200" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ApiService } from "@/common/api.service";
import {
  statusVariant,
  statusStr,
  transactionStatus,
} from "@/constants/transactionStatus";

export default {
  name: "recent-transactions",
  data() {
    return {
      transactions: null,
      statusVariant,
      statusStr,
      status: "loading",
    };
  },
  created() {
    ApiService.query("transaction?page=1&perpage=7", "").then((json) => {
      this.transactions = json.data.data.data;
      this.status = "ok";
    });
  },
};
</script>

<style scoped>
@media (max-width: 767.98px) {
  .recent-tx tbody tr {
    background: rgba(128, 128, 128, 0.1);
    border: 1px solid rgba(128, 128, 128, 0.35);
    border-inline-start: 4px solid #b5b5c3;
    border-radius: 12px;
    margin-bottom: 16px;
    padding: 2px 14px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  }
  .recent-tx tbody tr.tx-success { border-inline-start-color: #1bc5bd; }
  .recent-tx tbody tr.tx-danger { border-inline-start-color: #f64e60; }
  .recent-tx tbody tr.tx-primary { border-inline-start-color: #3699ff; }
  .recent-tx tbody td {
    padding: 10px 0;
    border-bottom: 1px dashed rgba(128, 128, 128, 0.4);
  }
  .recent-tx tbody td:last-child {
    border-bottom: 0;
  }
}
</style>